import React from "react";
import cs from "classnames";

import { StructureHeader } from "../StructureHeader/StructureHeader";
import { Icon, IconDefinition } from "../Icon/Icon";

import "./PageHeader.scss";

interface Props {
  title: string;
  message?: string;
  description?: React.ReactNode;
  hideBorder?: boolean;
  children?: React.ReactNode;
  className?: string;
  showUserViewType?: boolean;
  icon?: IconDefinition;
  userViewType?: string;
}

export const PageHeader = ({
  title,
  message,
  description,
  children,
  hideBorder,
  className,
  showUserViewType,
  icon,
  userViewType,
}: Props) => {
  const classes = cs("PageHeader", className, {
    "PageHeader--hide-border": hideBorder,
  });

  return (
    <div className={classes}>
      {icon && <Icon icon={icon} />}
      <StructureHeader
        title={title}
        message={message}
        description={description}
        hideBorder={hideBorder}
        showUserViewType={showUserViewType}
        userViewType={userViewType}
      />
      {children}
    </div>
  );
};
